import React from 'react'
import {Modal} from "../../fModal/Modal";
import {get} from "../../../../Model/Network/Config/Axios";
import {SearchableSelect} from "../../Class/Select/SearchableSelec2";
import {FloatInput} from '../../Class/FloatLabelInput';
import { showToast } from '../../fToast/ToastCallback';

class SearchVendor extends React.Component {


	state = {
        modal: false,
        allVendor: [],
        allGstins:[],
        vendors: null, 
        bankDetails: {},
        gstReturnStatus: undefined,
        gstReturnsFetchedAt: undefined,
        select: undefined,
        msmeId: undefined,
        pocs: undefined,
        panStatus: undefined
    }

 componentDidMount(){
    if(this.props.Vendor) {
        this.setState({
                vendors: this.props.multi ? (Array.isArray(this.props.Vendor) ? this.props.Vendor : [this.props.Vendor]) : (Array.isArray(this.props.Vendor) ? this.props.Vendor[0] : this.props.Vendor),
        })
    }
  }

    loadGstins = (item) => {
        if(!item) return;
        get(`/vendor/contacts/${item.value}/details`, (e, r) => {
            if(r && r.vendorStatus === 'BLOCKED'){
                showToast({ type: 'error', message: 'Vendor is Blocked' });
                this.setState({ vendors: this.props.multi ? [] : null, allGstins: [] });
                return;
            }
            if(r) {
                this.setState({
                    allGstins: r.addresses || [],
                    bankDetails: r.details || {},
                    panStatus: r.config && r.config.currentSpecifiedPersonDetails ? r.config.currentSpecifiedPersonDetails.panStatus : undefined,
                    eInvoiceApplicable: r.eInvoiceApplicable || false,
                    msmeId: r.msme && r.msme.msmeId ? r.msme.msmeId : undefined,
                    pocs: r.pocs && r.pocs.length > 0 ? r.pocs : undefined,
                    gstReturnStatus: r.gstReturnStatus,
                    gstReturnsFetchedAt: r.gstReturnsFetchedAt,
                    panDetails: r.config ? r.config.panDetails : undefined
                });
            }
        });
    }

    componentDidUpdate(prevProps) {
        if(this.props.value !== prevProps.value && !this.props.modal) {
            this.setState({
                vendors: this.props.multi ? (Array.isArray(this.props.value) ? this.props.value : [this.props.value]) : (Array.isArray(this.props.value) ? this.props.value[0] : this.props.value)
            });
        }
    }

    handleVendorSearch = (val) => {
        if(!val || val.length <= 2) return;
        let mData = { q: val };
        if(this.props.entityId) mData['entityId'] = this.props.entityId;
        if(this.props.officeId) mData['officeId'] = this.props.officeId;

        const tenant = this.props.tenant;
        const tenantFilter = this.props.tenantFilter;

        get(`/vendor/contacts/search`, (e, r) => {
            if(!r || !r.contacts) return;
            let vendors = r.contacts.map(v => ({
                label: v.title,
                value: v.id,
                tradeName: v.tradeName,
                currency: v.currency,
                des: v.registeredId,
                composition: v.composition,
                eInvoiceApplicable: v.eInvoiceApplicable,
                msmeId: v.msme && v.msme.msmeId ? v.msme.msmeId : undefined,
                pocs: v.pocs || undefined
            }));

            if(tenantFilter && tenant === "BSETEST"){
                vendors = vendors.filter(val => !val.des.includes("CONTACT"));
            }

            this.setState({ allVendor: vendors });
            if(this.props.onSearch){
                this.props.onSearch(r.contacts);
            }
        }, mData);
    }

    render() {
        const lastVendor = this.props.multi 
            ? (Array.isArray(this.state.vendors) && this.state.vendors.length > 0 ? this.state.vendors[this.state.vendors.length - 1] : null)
            : this.state.vendors;

        if(!this.props.modal){
            return (
                <div style={{position:'relative'}}>
                    <SearchableSelect
                        disabled={this.props.disabled}
                        label={this.props.multi && Array.isArray(this.state.vendors) && this.state.vendors.length ? "Selected Vendors (" + this.state.vendors.length + ")" : 'Select Vendor'}
                        placeholder="Select Vendor"
                        multi={this.props.multi}
                        value={this.props.multi ? null : this.state.vendors}
                        select={items => { 
                            const vendors = this.props.multi ? items : items;
                            this.setState({ vendors: vendors, allGstins: [], select: undefined });
                            
                            if(this.props.removeAddress) {
                                if(this.props.onSelect) {
                                    const vendorItems = this.props.multi ? items : [items];
                                    if(vendorItems && vendorItems.length > 0) {
                                        const vendorDataArray = vendorItems.map(vendor => ({
                                            id: vendor.value,
                                            name: vendor.label,
                                            label: vendor.label,
                                            currency: vendor.currency,
                                            composition: vendor.composition,
                                            eInvoiceApplicable: vendor.eInvoiceApplicable,
                                            ...(vendor.msmeId && { msmeId: vendor.msmeId }),
                                            ...(vendor.pocs && { pocs: vendor.pocs })
                                        }));
                                        this.props.onSelect(this.props.multi ? vendorDataArray : vendorDataArray[0]);
                                    }
                                }
                            } else {
                                const itemToLoad = this.props.multi ? (items.length > 0 ? items[items.length - 1] : null) : items;
                                if(itemToLoad) this.loadGstins(itemToLoad);
                            }
                        }}
                        onChange={this.handleVendorSearch}
                        items={this.state.allVendor}
                        style={{ color:'#e6ebf3', height:46, marginBottom:12 }}
                    />

                    {!this.props.removeAddress && this.state.allGstins.length > 0 && !this.state.select &&
                        <div style={{position:'absolute', top:'80px', right:0, width:'100%', maxHeight:'300px', border:'1px solid var(--border-color)', background:'var(--white-color)', overflowY:'scroll', borderRadius:'0px 0px 10px 10px', boxShadow:'0px 6px 4px rgba(0,0,0,0.1)', padding:'15px', zIndex:51}}>
                            <div style={{fontSize:11,fontWeight:'bold'}}>Select Address</div>
                            {this.state.allGstins.map((item,index)=>(
                                <div key={index} className='background-on-hover' style={{padding:'15px', marginTop:'10px', fontSize:'11px', background:'var(--lite-color)', borderRadius:'5px', cursor:'pointer'}}
                                    onClick={()=>{
									if (!lastVendor) return;

									const vendorData = {
										id: lastVendor.value,
										name: lastVendor.label,
										label: lastVendor.label,
										currency: lastVendor.currency,
										composition: lastVendor.composition,
										eInvoiceApplicable: lastVendor.eInvoiceApplicable,
										...(this.state.msmeId && { msmeId: this.state.msmeId }),
										...(this.state.pocs && { pocs: this.state.pocs }),
										address: item.address || "",
										city: item.city || "",
										gstin: item.gstin || "",
										state: item.state || "",
										key: item.id || "",
										panStatus: this.state.panStatus,
										bankDetails: this.state.bankDetails,
										gstReturnStatus: this.state.gstReturnStatus,
										gstReturnsFetchedAt: this.state.gstReturnsFetchedAt
									};

									if(this.props.multi) {
										const updatedVendors = this.state.vendors.map(v => {
											const address = v.value === lastVendor.value ? item : v.addressData || {};
											return {
												id: v.value,
												name: v.label,
												label: v.label,
												currency: v.currency,
												composition: v.composition,
												eInvoiceApplicable: v.eInvoiceApplicable,
												...(this.state.msmeId && { msmeId: this.state.msmeId }),
												...(this.state.pocs && { pocs: this.state.pocs }),
												address: address.address || "",
												city: address.city || "",
												gstin: address.gstin || "",
												state: address.state || "",
												key: address.id || "",
												panStatus: this.state.panStatus,
												bankDetails: this.state.bankDetails,
												gstReturnStatus: this.state.gstReturnStatus,
												gstReturnsFetchedAt: this.state.gstReturnsFetchedAt
											}
										});
										this.props.onSelect(updatedVendors);
									} else {
										this.props.onSelect(vendorData);
									}

                                        this.setState({
                                            select: {
                                                id: lastVendor.value,
                                                name: lastVendor.label,
                                                currency: lastVendor.currency,
                                                address: item.address,
                                                city: item.city,
                                                gstin: item.gstin,
                                                state: item.state,
                                                email: lastVendor.email,
                                                key: item.id
                                            },
                                            modal: false,
                                            allVendor: [],
                                            allGstins: []
                                        })
                                    }}>
                                    <div style={{fontSize:12, fontWeight:600}}>{(item && item.title) || ''}</div>
                                    <div>{(item && item.address) || ''}</div>
                                    <div>{(item && item.city) || ''}, {(item && item.state) || ''}</div>
                                    <div>{(item && item.gstin) || ''}</div>
                                </div>
                            ))}
                        </div>
                    }
                </div>
            )
        }

        return (
            <div>
                <div style={{cursor:'pointer'}}>
                    <FloatInput
                        type="text"
                        title="Search Vendor"
                        handleRef={ref => this.vendor = ref}
                        disabled={true}
                        onClick={() => this.setState({ modal: true })}
                    />
                </div>

                {this.state.modal &&
                    <Modal show={true} title="Select Vendor" des="Please select a vendor to continue." hideButton={true} close={() => this.setState({ modal:false })}>
                        <SearchableSelect
                            label="Select Vendor"
                            placeholder="Select Vendor"
                            multi={this.props.multi}
                            value={this.props.multi ? null : this.state.vendors}
                            select={items => {
                                const vendors = this.props.multi ? items : items;
                                this.setState({ vendors: vendors, allGstins: [] });
                                
                                if(this.props.removeAddress) {
                                    if(this.props.onSelect) {
                                        const vendorItems = this.props.multi ? items : [items];
                                        if(vendorItems && vendorItems.length > 0) {
                                            const vendorDataArray = vendorItems.map(vendor => ({
                                                id: vendor.value,
                                                name: vendor.label,
                                                label: vendor.label,
                                                currency: vendor.currency,
                                                composition: vendor.composition,
                                                eInvoiceApplicable: vendor.eInvoiceApplicable,
                                                ...(vendor.msmeId && { msmeId: vendor.msmeId }),
                                                ...(vendor.pocs && { pocs: vendor.pocs })
                                            }));
                                            this.props.onSelect(this.props.multi ? vendorDataArray : vendorDataArray[0]);
                                        }
                                    }
                                } else {
                                    const itemToLoad = this.props.multi ? (items.length > 0 ? items[items.length - 1] : null) : items;
                                    if(itemToLoad) this.loadGstins(itemToLoad);
                                }
                            }}
                            onChange={this.handleVendorSearch}
                            items={this.state.allVendor}
                            style={{ color:'#e6ebf3', height:46, marginBottom:12 }}
                        />

                        {!this.props.removeAddress && this.state.allGstins.length > 0 &&
                            <div>
                                <p style={{fontSize:11,color:'var(--light-color)',marginTop:8}}>All Addresses</p>
                                {this.state.allGstins.map(item => (
                                    <div key={item.id} style={{position:'relative',marginTop:8}}>
                                        <p style={{fontSize:15, fontWeight:600, color:"var(--text-color)"}}>{(item && item.title) || ''}</p>
                                        <p style={{fontSize:11, color:"var(--light-color)"}}>{(item && item.address) || ''}</p>
                                        <p style={{fontSize:11, color:"var(--light-color)"}}>{(item && item.city) || ''}, {(item && item.state) || ''}</p>
                                        <p style={{fontSize:11, color:"var(--light-color)"}}>{(item && item.gstin) || ''}</p>
                                        <p onClick={() => {
											const vendorData = {
                                                id: lastVendor.value,
                                                name: lastVendor.label,
                                                composition:lastVendor.composition,
                                                eInvoiceApplicable:lastVendor.eInvoiceApplicable,
                                                ...(this.state.msmeId && { msmeId: this.state.msmeId }),
                                                ...(this.state.pocs && { pocs: this.state.pocs }),
                                                address:item.address,
                                                city:item.city,
                                                gstin:item.gstin,
                                                state:item.state,
                                                key:item.id,
                                                panStatus: this.state.panStatus,
                                                gstReturnStatus:this.state.gstReturnStatus,
                                                gstReturnsFetchedAt:this.state.gstReturnsFetchedAt
											};
											this.props.onSelect(this.props.multi ? [vendorData] : vendorData);
                                            this.vendor.setValue(lastVendor.label);
                                            this.setState({ select: { id:lastVendor.value, name:lastVendor.label, address:item.address, city:item.city, gstin:item.gstin, state:item.state, email:lastVendor.email, key:item.id }, modal:false, allGstins:[], allVendor:[] });
                                        }} style={{ position:'absolute', right:0, top:12, width:80, height:24, color:'#fff', background:'var(--primary-color)', cursor:'pointer', borderRadius:2, padding:5, fontWeight:600, fontSize:11, textAlign:'center' }}>Select</p>
                                    </div>
                                ))}
                            </div>
                        }
                    </Modal>
                }
            </div>
        )
    }
}

SearchVendor.defaultProps = { disabled:false, multi:false, removeAddress:false };
export default SearchVendor;
